var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.70eda171db1bb91808b9592184bdf5a7.svg#M';
                    var viewUrl = 'sprites.70eda171db1bb91808b9592184bdf5a7.svg#view-M';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 95 95',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };